
import fe from "@randajan/simple-app/fe";
import jet from "@randajan/jet-core";

import "./style.css";
import "./apps";






window.jet = jet;